import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  CreateTkv2OrderAPIError,
  CreateTkv2OrderAPIVariables,
  fetchCreateTkv2OrderAPI,
} from '../toolkitComponents.js';
import { useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schResponse>;
const {
  schemas: { REQUEST: schRequest, RESPONSE: schResponse },
} = Registry.createTkv2OrderAPI;

export const useCreateTkv2OrderAPI = (
  options?: Omit<
    UseMutationOptions<Response, CreateTkv2OrderAPIError, CreateTkv2OrderAPIVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Response, CreateTkv2OrderAPIError, CreateTkv2OrderAPIVariables>(
    (variables: CreateTkv2OrderAPIVariables) =>
      fetchCreateTkv2OrderAPI({
        ...fetcherOptions,
        ...variables,
        body: schRequest.BODY.parse(variables.body),
      }).then((r) => schResponse.parse(r)),
    options,
  );
};
